import { createSlice } from '@reduxjs/toolkit';
import { VOLUNTEERS_SERVICE } from '../constants';
import initialState from '../initialStates/volunteersService';
import utils from '../../utils';

const slice = createSlice({
  name: VOLUNTEERS_SERVICE,
  initialState: initialState,
  reducers: {
    setVolunteers(state, action) {
      const { volunteers } = action.payload;
      state.volunteers = volunteers;
    },
    sort(state, action) {
      const { sortedByDesc, key, areHours, areDates } = action.payload;
      const result = state.volunteers.sort((a, b) => {
        if (areHours) {
          if (sortedByDesc) {
            if (Number(a[key]) < Number(b[key])) {
              return -1;
            }
            if (Number(a[key]) > Number(b[key])) {
              return 1;
            }
          } else {
            if (Number(a[key]) > Number(b[key])) {
              return -1;
            }
            if (Number(a[key]) < Number(b[key])) {
              return 1;
            }
          }
        } else if (areDates) {
          if (sortedByDesc) {
            if (
              utils.convertDate(a[key], true) < utils.convertDate(b[key], true)
            ) {
              return -1;
            }
            if (
              utils.convertDate(a[key], true) > utils.convertDate(b[key], true)
            ) {
              return 1;
            }
          } else {
            if (
              utils.convertDate(a[key], true) > utils.convertDate(b[key], true)
            ) {
              return -1;
            }
            if (
              utils.convertDate(a[key], true) < utils.convertDate(b[key], true)
            ) {
              return 1;
            }
          }
        } else {
          if (sortedByDesc) {
            if (a[key] < b[key]) {
              return -1;
            }
            if (a[key] > b[key]) {
              return 1;
            }
          } else {
            if (a[key] > b[key]) {
              return -1;
            }
            if (a[key] < b[key]) {
              return 1;
            }
          }
        }
        return 0;
      });

      state.volunteers = result;
    },
  },
});

const sortingReducer = {
  [VOLUNTEERS_SERVICE]: slice.reducer,
};

export const { setVolunteers, sort } = slice.actions;
export default sortingReducer;
